/* src/app/common/components/item-upsertion/item-upsertion.component.scss */
.template-selection-link,
.template-selection-link.ion-activatable:hover {
  --color-hover: var(--ion-color-primary);
  color: var(--ion-color-primary);
}
.template-selection-link ion-icon {
  margin-right: 12px;
}
.template-selection-link ion-label {
  max-width: unset;
  overflow: visible;
}
.template-selection-link .indicator {
  position: absolute;
  right: 9px;
  top: 12px;
  z-index: 2;
  background-color: var(--ion-color-success);
  width: 12px;
  height: 12px;
  border-radius: 50%;
}
.selection-name {
  flex-grow: 0;
  flex-basis: unset;
}
::ng-deep ion-radio-group .radio-group-wrapper {
  display: flex;
  align-items: center;
  justify-content: end;
}
.banner .thumbnail {
  height: 180px;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
  border-radius: 8px;
  margin: 10px;
  position: relative;
}
.banner .thumbnail .change-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 50px;
  background: rgba(0, 0, 0, 0.75);
  color: #fff;
  font-size: 14px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
}
.banner .thumbnail .change-overlay ion-icon {
  margin-right: 6px;
}
.banner .image-upload-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0.8rem;
  margin: 0.5rem auto;
  border-radius: 10px;
  max-width: 500px;
}
.banner .image-upload-wrapper .image-upload-bg {
  width: 100%;
  min-height: 150px;
  background-image: url(https://ionicframework.com/docs/demos/api/thumbnail/thumbnail.svg);
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  border: 2px dashed var(--ion-color-medium);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.banner .image-upload-wrapper .image-upload {
  text-align: center;
  background-color: rgba(255, 255, 255, 0.85);
  padding: 1rem;
  border-radius: 12px;
}
.banner .image-upload-wrapper .image-upload ion-icon {
  font-size: 3rem;
  color: var(--ion-color-primary);
  margin-bottom: 8px;
}
.banner .image-upload-wrapper .image-upload h3 {
  font-size: 1rem;
  color: var(--ion-color-dark);
  margin-bottom: 8px;
}
.banner .image-upload-wrapper .image-upload .browse-btn {
  display: inline-block;
  padding: 6px 12px;
  background-color: var(--ion-color-primary);
  color: white;
  border-radius: 20px;
  cursor: pointer;
}
.banner .image-upload-wrapper .image-upload input[type=file] {
  display: none;
}
.smartdine-form {
  padding: 6px 12px;
}
.smartdine-form ion-item {
  --background: #fbfefc;
  border-radius: 10px;
  margin-bottom: 4px;
  --inner-padding-end: 15px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}
.smartdine-form ion-item.radio {
  --background: #fff;
}
.smartdine-form ion-item ion-label {
  min-width: 120px;
  font-weight: 600;
  color: var(--ion-color-primary);
  font-size: 14px;
}
.smartdine-form ion-item ion-input,
.smartdine-form ion-item ion-select {
  text-align: right;
}
.smartdine-form .required-star {
  color: var(--ion-color-danger);
  margin-left: 4px;
}
.smartdine-form small.error-text {
  color: var(--ion-color-danger);
  display: block;
  text-align: right;
  font-size: 12px;
  padding: 2px 4px 6px;
}
/*# sourceMappingURL=item-upsertion.component.css.map */
